export default "__VITE_ASSET__C_sSk$Ll__"